import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="bg-periwinkle py-24 px-6 md:px-12 text-center" data-id="element-37">
      <div className="max-w-4xl mx-auto" data-id="element-38">
        <FadeIn data-id="element-39">
          <h2 className="text-4xl md:text-6xl text-cream mb-6" data-id="element-40">
            Hoy puede ser la última noche así
          </h2>
          <p className="text-cream/80 text-xl md:text-2xl mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-41">
            No tenés que seguir aguantando. Con esta guía, esta misma noche
            podés empezar a cambiar la forma en que tu bebé duerme — y vos
            también.
          </p>
          <CTAButton className="text-xl md:text-2xl py-6 px-10 mb-6 shadow-2xl" data-id="element-42">
            Quiero empezar a descansar
          </CTAButton>
          <p className="text-cream/60 text-sm" data-id="element-43">
            Pago único · Acceso inmediato · Sin suscripciones
          </p>
        </FadeIn>
      </div>
    </section>;
}